<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 质量抽查</div>
      <a-space>
        <!-- <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day> -->
        <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button>
      </a-space>
    </div>
    <form-vue
      ref="fqcRef"
      @updateTable="updateTable"
      :type="props.type"
      :produceOrTpc="props.produceOrTpc"
    ></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table
            :columns="productColumns"
            :loading="tableLoading"
            :data-source="tableData"
            :pagination="false"
            :rowClassName="
              (record, index) => (index % 1 === 0 ? 'table-striped' : null)
            "
            rowKey="id"
            bordered
            :scroll="{ x: 'calc(100vw - 160px)' }"
          >
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small"
                  >编辑</a-button
                >

                <a-button
                  v-if="props.deleteAuthority"
                  @click="handleDelete(record)"
                  size="small"
                  type="danger"
                  >删除</a-button
                >
              </a-space>
            </template>

            <template #picture="{ record }">
              <a-image
                v-for="img in JSON.parse(record.picture)"
                :key="img"
                :width="50"
                :src="img"
              />
            </template>

            <template #video="{ record }">
              <video
                v-for="video in JSON.parse(record.video)"
                :src="video"
                controls
                width="120"
                :key="video"
              ></video>
            </template>

            <template #isEducation="{ record }">
              {{ record.isEducation ? "是" : "否" }}
            </template>

            <template #isTrain="{ record }">
              {{ record.isTrain ? "是" : "否" }}
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, watch, inject } from "vue";
import {
  getQualitySpotCheckList,
  deleteQualitySpotCheck,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/qualitySpotCheck/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { useStore } from "vuex";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    deleteAuthority: Boolean,
    type: String,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: props.type,
      produceOrTpc: props.produceOrTpc
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "抽查内容",
        dataIndex: "spotCheckContent",
        width: 160,
        align: "center",
      },
      {
        title: "抽查组员",
        dataIndex: "spotCheckPerson",
        width: 165,
        align: "center",
      },
      {
        title: "抽查",
        align: "center",
        children: [
          {
            title: "情况",
            dataIndex: "spotCheckSituation",
            width: 165,
            align: "center",
          },
          {
            title: "图片",
            dataIndex: "picture",
            width: 165,
            align: "center",
            slots: {
              customRender: "picture",
            },
          },
          {
            title: "视频",
            dataIndex: "video",
            width: 165,
            align: "center",
            slots: {
              customRender: "video",
            },
          },
        ],
      },
      {
        title: "原因",
        dataIndex: "reason",
        width: 165,
        align: "center",
      },
      {
        title: "批评教育",
        width: 165,
        align: "center",
        slots: {
          customRender: "isEducation",
        },
      },
      {
        title: "员工态度",
        dataIndex: "employeeAttitude",
        width: 165,
        align: "center",
      },
      {
        title: "培训",
        width: 165,
        align: "center",
        slots: {
          customRender: "isTrain",
        },
      },
      {
        title: "首样确认",
        dataIndex: "firstConfirm",
        width: 165,
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 160,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const getTableData = () => {
      tableLoading.value = true;
      getQualitySpotCheckList(query)
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            res.data[props.type]
          ) {
            tableData.push(...res.data[props.type]);
            // tableData.forEach((item) => {
            //   item.isEducation = item.isEducation ? "是" : "否";
            //   item.isTrain = item.isTrain ? "是" : "否";
            // });
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteQualitySpotCheck([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editQualitySpotCheck", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addQualitySpotCheck");
    };

    const updateTable = () => {
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      userId,
      query,
      handleDelete,
      userSelectDay,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      tableScrollRef,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
